//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'HeroSection',
  methods: {
    knowMore () {
      setTimeout(() => {
        return window.scrollTo({
          top: document.querySelector('#pagsmileCard').offsetTop,
          behavior: 'smooth'
        })
      }, 250)
    },
    getStarted () {
      this.$router.push('/pagsmile-card/form')
    }
  }
}
